import { useMemo } from "react";
import { useAppSelector } from "@/store/store";

export const useCurrentUser = () => {
  const user = useAppSelector((state) => state.user.user);

  return useMemo(
    () => ({
      user, 
      userId: user?.id ?? "",
      siteId: user?.site?.id ?? "",
      isAuthenticated: !!user,
    }),
    [user],
  );
};
